export const LEGACY_EXPAND_ALL_COMMENTS_SETTING = "expand_all_comments";
export const SHOW_RESERVATION_DETAILS_BY_VIEW_SETTING = "show_reservation_details_by_view";


// WEBPACK FOOTER //
// ./src/constants/settings.js